import styled from 'styled-components';

export const FormWrapper = styled.div`
  width: 100%;
  .ant-input-textarea {
    .ant-input {
      resize: none;
      height: 214px;
      border-radius: 4px;
    }
  }
  .tox .tox-statusbar {
    display: none;
  }
`;

export const EmailTemplateFormWrapper = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  .email-template-form {
    width: 100%;
    max-width: 900px;
  }
`;
